import {configureStore} from "@reduxjs/toolkit";
import appSlice from './module/app'

const store = configureStore({
  reducer: {
    app: appSlice,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    // 关闭redux序列化检测
    serializableCheck: false
  })
})

export default store

